import 'promise-polyfill/src/polyfill';

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === "number" &&
           isFinite(value) &&
           Math.floor(value) === value;
};

Number.prototype.round = Number.prototype.round || function(places) {
  return +(Math.round(this + "e+" + places)  + "e-" + places);
};

// FYI: polyfill for send beacon. IE11 does not support this feature
// hence adding this until we remove support for IE11
if (typeof window.navigator["sendBeacon"] === "undefined") {
  window.navigator["sendBeacon"] = function (url, data) {
      var event = window.event && window.event.type;
      var sync = event === "unload" || event === "beforeunload";
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, !sync);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Accept", "*/*");
      if (typeof data === "string") {
          xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
          xhr.responseType = "text";
      } else if (data instanceof Blob && data.type) {
          xhr.setRequestHeader("Content-Type", data.type);
      }

      try {
          xhr.send(data);
      } catch (error) {
          return false;
      }

      return true;
  };
}
